/**
 * Typed crypto failures. Codes are internal; callers map them to registry
 * codes (`OP_PDF_*`, `OP_BACKUP_*`, `OP_STORAGE_*`) before any API response.
 */
export type CryptoErrorCode =
  | 'CRYPTO_INVALID_INPUT'
  | 'CRYPTO_INVALID_KEY'
  | 'CRYPTO_AUTH_FAILED'
  | 'CRYPTO_JCS_UNSUPPORTED_VALUE'
  | 'CRYPTO_JSON_DUPLICATE_KEY'
  | 'CRYPTO_JSON_PARSE_ERROR'
  | 'CRYPTO_TAG_LENGTH_UNSUPPORTED'

export class CryptoError extends Error {
  readonly code: CryptoErrorCode

  constructor(code: CryptoErrorCode, message: string) {
    super(message)
    this.name = 'CryptoError'
    this.code = code
  }
}
